import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../services/api';
import './ForgotPassword.css';

function ForgotPassword() {
  const [identifier, setIdentifier] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setMessage('');

    if (!identifier.trim()) {
      setError('Please enter your User ID or email address');
      return;
    }

    setLoading(true);

    try {
      const response = await api.post('/auth/forgot-password', {
        identifier: identifier.trim()
      });

      if (response.data.success) {
        setMessage(response.data.message);
        setSubmitted(true);
      } else {
        setError(response.data.message);
      }
    } catch (err) {
      if (err.response?.data?.message) {
        setError(err.response.data.message);
      } else {
        setError('An error occurred. Please try again later.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="forgot-password-container">
      <div className="forgot-password-logo-container">
        <img src="/logo.png" alt="Hanwha Power" className="login-logo-img" />
      </div>

      <div className="forgot-password-header-bar">Password Reset</div>

      <div className="forgot-password-content">
        <div className="forgot-password-box">
          {!submitted ? (
            <>
              <h2>Forgot Your Password?</h2>
              <p className="forgot-password-instruction">
                Enter your User ID or email address and we'll send you a link to reset your password.
              </p>

              {error && (
                <div className="error-message-box">
                  <span className="error-icon">⚠</span>
                  <span>{error}</span>
                </div>
              )}

              <form onSubmit={handleSubmit}>
                <div className="form-group">
                  <label htmlFor="identifier">User ID or Email</label>
                  <input
                    type="text"
                    id="identifier"
                    value={identifier}
                    onChange={(e) => setIdentifier(e.target.value)}
                    placeholder="Enter your User ID or email"
                    disabled={loading}
                    autoFocus
                  />
                </div>

                <div className="form-group">
                  <button 
                    type="submit" 
                    className="reset-button" 
                    disabled={loading}
                  >
                    {loading ? 'Sending...' : 'Send Reset Link'}
                  </button>
                </div>
              </form>

              <div className="back-to-login">
                <Link to="/login">← Back to Login</Link>
              </div>
            </>
          ) : (
            <>
              <div className="success-message-box">
                <span className="success-icon">✓</span>
                <h2>Check Your Email</h2>
              </div>
              <p className="success-instruction">
                {message}
              </p>
              <p className="success-instruction">
                The email will contain a link to reset your password. The link will expire in 30 minutes.
              </p>
              <div className="form-group">
                <Link to="/login" className="back-to-login-button">
                  Return to Login
                </Link>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default ForgotPassword;
